import React, {useContext, useEffect, useState} from "react";
import AgendaService from "../../services/agenda.service";
import BootstrapModal from "./BootstrapModal";
import Columna from "../../models/Columna";
import {ACTIONS} from "../../config/constants";
import {StateContext} from "../context/StateProvider";
import Toasts from "../notificacion/Toasts";

const ColumnManagerModal = ({ visible, onClose, state, dispatch }) => {
    const {updateState} = useContext(StateContext)

    const [rows, setRows] = useState(() => state.columnOrder.map((id) => ({ id, name: state.columns[id].name })))
    const [newId, setNewId] = useState('')
    const [newName, setNewName] = useState('')

    useEffect(() => {
        if (visible) {
            setRows(state.columnOrder.map((id) => ({ id, name: state.columns[id].name })))
            setNewId('')
            setNewName('')
        }
    }, [visible, state])

    const applyChanges = async () => {
        // renombres
        try {
            for (const r of rows) {
                if (state.columns[r.id]?.name !== r.name) {
                    await AgendaService.renombrarColumna(r.id, r.name)
                    dispatch({ type: ACTIONS.RENAME_COLUMN, payload: { id: r.id, name: r.name } })
                }
            }
            const nextOrder = rows.map((r) => r.id)
            if (nextOrder.join('|') !== state.columnOrder.join('|')) {
                await AgendaService.reordenarColumnas(nextOrder)
                dispatch({ type: ACTIONS.SET_COLUMN_ORDER, payload: { order: nextOrder } })
            }
            onClose()
        } catch {
            const toasts = Toasts.generateToast('No se pudieron aplicar los cambios de columnas', 'error');
            updateState({toasts: [...state.toasts, toasts]})
        }
    }

    return (
        <BootstrapModal
            show={visible}
            title="Columnas"
            onClose={onClose}
            size="lg"
            footer={
                <>
                    <button className="btn btn-secondary" onClick={onClose}>
                        Cerrar
                    </button>
                    <button className="btn btn-primary" onClick={applyChanges}>
                        Aplicar
                    </button>
                </>
            }
        >
            <div className="d-grid gap-3">
                <div>
                    <div className="fw-semibold mb-2">Listado</div>
                    <div className="list-group">
                        {rows.map((r) => (
                            <div key={r.id} className="list-group-item d-flex align-items-center gap-2">
                <span className="text-muted small" style={{ width: 120 }}>
                  {r.id}
                </span>
                                <input
                                    className="form-control"
                                    value={r.name}
                                    onChange={(e) => setRows((prev) => prev.map((x) => (x.id === r.id ? { ...x, name: e.target.value } : x)))}
                                />
                                <div className="ms-auto d-flex gap-2">
                                    <button
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={async () => {
                                            const id = r.id
                                            const prev = state
                                            setRows((p) => p.filter((x) => x.id !== id))
                                            dispatch({
                                                type: ACTIONS.DELETE_COLUMN,
                                                payload: { id, fallback: 'backlog', dropStrategy: 'delete' },
                                            })
                                            try {
                                                await AgendaService.eliminarColumna(id)
                                            } catch {
                                                dispatch({ type: ACTIONS.INIT_FROM_API, payload: prev })
                                                const toasts = Toasts.generateToast('No se pudo eliminar la columna', 'error');
                                                updateState({toasts: [...state.toasts, toasts]})
                                            }
                                        }}
                                        disabled={rows.length <= 1}
                                    >
                                        Eliminar
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="border-top pt-3">
                    <div className="fw-semibold mb-2">Nueva columna</div>
                    <div className="row g-2">
                        <div className="col-md-4">
                            <input
                                className="form-control"
                                placeholder="ID (slug)"
                                value={newId}
                                onChange={(e) => setNewId(e.target.value.replace(/\s+/g, '-').toLowerCase())}
                            />
                        </div>
                        <div className="col-md-6">
                            <input
                                className="form-control"
                                placeholder="Nombre visible"
                                value={newName}
                                onChange={(e) => setNewName(e.target.value)}
                            />
                        </div>
                        <div className="col-md-2 d-grid">
                            <button
                                className="btn btn-primary"
                                disabled={!newId.trim() || state.columns[newId]}
                                onClick={async () => {
                                    const id = newId.trim()
                                    const name = newName.trim() || id
                                    const prev = state
                                    setRows((p) => [...p, { id, name }])
                                    dispatch({ type: ACTIONS.ADD_COLUMN, payload: { id, name } })
                                    setNewId('')
                                    setNewName('')
                                    try {
                                        await AgendaService.crearColumna(new Columna({ id, name }))
                                    } catch {
                                        dispatch({ type: ACTIONS.INIT_FROM_API, payload: prev })
                                        const toasts = Toasts.generateToast('No se pudo crear la columna', 'error');
                                        updateState({toasts: [...state.toasts, toasts]})
                                    }
                                }}
                            >
                                Añadir
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </BootstrapModal>
    )
}

export default ColumnManagerModal;